import styled from 'styled-components';

export default styled.div`
  background: ${(props) => props.theme.carvana.white.primary};
  border: 0;
  border-radius: 3px;
  box-shadow: 0 2px 3px rgba(24, 53, 88, 0.18);
  box-sizing: content-box;
  margin: 50px auto;
  max-width: 350px;
  padding: 50px 75px;
  text-align: left;

  @media only screen and (max-width: 500px) {
    border-radius: 0;
    margin: 0;
  }
`;
